import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

// import {
//   TypeRefundTicketAvia,
//   TypeRefundTicketAviaList,
// } from 'shared/constants'
// import { BlockSelect, TYPE_RESULT } from 'shared/ui/block-select'
import { ButtonContinue } from 'shared/ui/bottom-continue'
import { HeaderResetButton } from 'shared/ui/header-reset-button'

import { ComfortFilter } from '../filter-search-screen/components'
import { useFilterState } from '../filter-search-screen/hooks'

import s from './styles.module.scss'

const FilterTransfersScreen = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const {
    state,
    filterDataFromRequest,
    isDisabledComfort,
    hasActiveFilters,
    hasChanges,
    onResetFields,
    onSubmit,
    onChangeComfortFilter,
    // onChangeTypeRefund,
  } = useFilterState()

  const onBack = () => {
    navigate(-1)
  }

  const onReset = () => {
    onResetFields([
      'durationOfTransfers',
      'isWithChangeAirport',
      'isWithRepeatRegistration',
      'isWithNightTransition',
      // 'refundTicket',
    ])
  }

  return (
    <div className="container">
      <HeaderResetButton
        title={t('transfers')}
        isCanDisable={hasActiveFilters}
        onBack={onBack}
        onReset={onReset}
      />

      <div className={s.list}>
        {/* <div className={s.itemBlock}>
          <BlockSelect
            typeOption={TYPE_RESULT.RADIO}
            title={t('avia_refund_ticket')}
            active={[state?.refundTicket || TypeRefundTicketAvia.All.key]}
            listOption={TypeRefundTicketAviaList?.map((option) => ({
              key: option.key,
              title: t(option.name),
            }))}
            onChange={(value) => onChangeTypeRefund(value as string)}
          />
        </div> */}

        <ComfortFilter
          isDisabled={isDisabledComfort}
          filter={state}
          maxValue={{
            min: filterDataFromRequest?.transferTimer?.min_duration,
            max: filterDataFromRequest?.transferTimer?.max_duration,
          }}
          onChangeComfortFilter={onChangeComfortFilter}
        />
      </div>

      <ButtonContinue
        onClick={onSubmit}
        disabled={!hasChanges}
      >
        <span className="semi-bold-17">{t('apply')}</span>
      </ButtonContinue>
    </div>
  )
}

export default FilterTransfersScreen
